export const sendTrovitLead = (siteKey) => {
  ('at ch de dk se').includes(siteKey) && ta && ta('send', 'lead');
}
